import { legacyPayment } from './legacyPayment'
import * as superstoryPayment from './superstory/payment'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

const payment = loadBrandConfig({
  rocnovel: legacyPayment,
  oceread: legacyPayment,
  ficmoon: legacyPayment,
  storyella: legacyPayment,
  aurenovel: legacyPayment,
  florastory: legacyPayment,
  silktale: legacyPayment,
  freefic: legacyPayment,
  pearla: legacyPayment,
  fictora: legacyPayment,
  marinovel: legacyPayment,
  talewave: legacyPayment,
  moonpage: legacyPayment,
  novelune: legacyPayment,
  storlyn: legacyPayment,
  novaris: legacyPayment,
  novelyn: legacyPayment,
  flipnovel: legacyPayment,
  novelarc: legacyPayment,
  novelsprig: legacyPayment,
  novelmello: legacyPayment,
  superstory: superstoryPayment,
})

export const { rememberCheckout, orderCreated, paymentConfirmed, paymentFailed } = payment
